module.exports = __webpack_public_path__ + "static/logo2-66ecbe543e1f21206bc934c8fbea4b34.svg";